import { axiosClient } from '@/features'
import { DelegateConfirmResponse, DelegateRequest, DelegateResponse } from '@/features/Cards/cards.types'
import { ApiRoutes } from '@/routes'

export const delegateService = {
  delegate: async ({ fromWalletAddress, tokenAmount, mint }: DelegateRequest): Promise<DelegateResponse> => {
    const delegateReq = await axiosClient.post<DelegateResponse>(ApiRoutes.DELEGATE_CARD, {
      fromWalletAddress,
      tokenAmount,
      mint,
    })
    return delegateReq.data
  },

  revoke: async (wallet: string, mint: string) => {
    const revokeReq = await axiosClient.post(ApiRoutes.DELEGATE_REVOKE, {
      fromWalletAddress: wallet,
      mint,
    })
    return revokeReq.data
  },

  confirm: async (signature: string, transactionId: string): Promise<DelegateConfirmResponse> => {
    const confirmReq = await axiosClient.post<DelegateConfirmResponse>(ApiRoutes.DELEGATE_CARD_CONFIRM, {
      transactionId,
      signedTransactionBase58: signature,
    })
    return confirmReq.data
  },

  getBalances: async () => {
    const req = await axiosClient.get(ApiRoutes.DELEGATE_BALANCES)
    return req.data
  },

  getSuggestions: async (tokenAddress: string) => {
    const req = await axiosClient.get(ApiRoutes.DELEGATE_SUGGESTIONS, {
      params: { tokenAddress },
    })
    return req.data
  },
}
